'use strict';

var _ = require('lodash');

function SettingsOrgSitesController (
  $http,
  $location,
  $rootScope,
  $scope,
  $state,
  $window,
  organization,
  OrganizationStore,
  SettingsStore,
  AnalyticsService,
  IdentityService,
  NgTableParams
) {

  const vm = this;
  const uploaderSite = IdentityService.get('uploadUrl');
  let uploaderToken = '';

  vm.org = organization;
  vm.activeSiteId = _.get($state, ['params', 'site']);
  vm.filterInput = '';
  vm.sites = _formatSites();
  vm.showSpinner = true;
  vm.isIngestorUser = IdentityService.isIngestBetaUser();

  $rootScope.$on('$stateChangeStart', function(event, toState, toParams){
    vm.activeSiteId = toParams.site;
  });

  vm.tableParams = new NgTableParams({
    count: vm.org.projects.length,
    // initial sort order
    sorting: {
      name: 'asc'
    }
  }, {
    filterDelay: 0,
    dataset: vm.org.projects,
    counts: []
  });

  // ensure that this controller always recognizes when the detailed view is open, even on page refresh
  if ($location.path().split('/').length === 5) {
    vm.state = 'detailed';
  } else {
    vm.state = 'overview';
  }

  function filterSites (sites, filter) {
    if (!filter) {
      return sites;
    }

    return _.filter(sites, function(site) {
      return site.name.toLowerCase().indexOf(filter.toLowerCase()) !== -1;
    });
  }

  function _formatSites () {
    var projects = _.cloneDeep(OrganizationStore.get('projects'));
    var sites = [];
    var users = OrganizationStore.get('users');
    projects.forEach(function(project) {
      project.sites.forEach(function(site) {
        var count = users.filter(function(user) {
          return _.find(user.userSites, { id: site.id });
        }).length;
        sites.push({
          id: site.id,
          name: site.name,
          userCount: count
        });
      });
    });

    return sites;
  }

  vm.onFilterChange = function(newFilter) {
    vm.org.filteredSites = filterSites(vm.sites, newFilter);
  };

  vm.viewSite = function viewSite (id) {
    $state.go('settings.organization.sites.detail', { site: id });

    vm.state = 'detailed';
  };

  vm.updateUploaderUrl = () => {

    const url = IdentityService.getAuthApiUri() + '/sso';

    const httpConfig = {
      url: url,
      method: 'POST'
    };

    return $http(httpConfig)
    .then((payload) => {

      const data = payload.data.data;
      uploaderToken = data.token;
    })
    .catch((payload, status) => {

      console.warn('SSO fetch failed', payload, status);
    });
  };

  vm.toggleUploader = _.debounce(() => {

    if (vm.isIngestorUser) {
      $state.go('uploader')
    }
    else {
      let url;
      console.log(uploaderToken);
    
      if (uploaderToken) {
        url = uploaderSite + 'login?token=' + uploaderToken + '&orgId=' + IdentityService.get('currentOrganization').id;
      }
      else {
        url = uploaderSite;
      }
      $window.open(url, '_blank');
    }    
  }, 0);

  vm.updateUploaderUrl();

  /**======     Flux Handlers and Registry    ======**/
  vm.handleCloseDetailView = function handleCloseDetailView () {
    vm.state = 'overview';
    vm.activeSiteId = null;
  };

  vm.handleOpenDetailView = function handleOpenDetailView () {
    vm.state = 'detailed';
  };

  vm._handleOrganizationStoreDeletedProject = (deletedProject) => {

    vm.org.projects = OrganizationStore.get('projects');
    vm.sites = _formatSites();

    vm.tableParams.settings().dataset = vm.org.projects;
    vm.tableParams.total(vm.org.projects.length);
    vm.tableParams.reload();

    if ($state.is('settings.organization.sites.detail')) {
      if (deletedProject.id == vm.activeSiteId) {
        $state.go('settings.organization.sites');
      }
    }
  };

  SettingsStore.on(SettingsStore.Events.CloseDetailView, this.handleCloseDetailView.bind(this), $scope);
  SettingsStore.on(SettingsStore.Events.OpenDetailView, this.handleOpenDetailView.bind(this), $scope);
  OrganizationStore.on(OrganizationStore.Events.DeletedProject, this._handleOrganizationStoreDeletedProject.bind(this));
}

SettingsOrgSitesController.$inject = [
  '$http',
  '$location',
  '$rootScope',
  '$scope',
  '$state',
  '$window',
  'organization',
  'OrganizationStore',
  'SettingsStore',
  'AnalyticsService',
  'IdentityService',
  'NgTableParams'
];

module.exports = SettingsOrgSitesController;



// WEBPACK FOOTER //
// ./src/app/settings/orgSites/SettingsOrgSitesController.js